import { render, staticRenderFns } from "./RelatorioMensalMes.vue?vue&type=template&id=0f8a6dce"
import script from "./RelatorioMensalMes.vue?vue&type=script&lang=ts"
export * from "./RelatorioMensalMes.vue?vue&type=script&lang=ts"
import style0 from "./RelatorioMensalMes.vue?vue&type=style&index=0&id=0f8a6dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports